import { useEffect, useMemo, useRef, useState } from "react";

const normalizeSentimentValue = (value) => {
  if (value == null || value === "") return null;

  const parsedValue = Number(value);
  if (!Number.isFinite(parsedValue)) return null;

  return Math.max(-1, Math.min(1, parsedValue));
};

// The streamed sentiment clamped to [-1, 1] (null when missing), and its change
// since the previous reading. The change resets when `resetKey` (the
// instrument) changes, so readings for two instruments are never compared.
export const useLiveSentiment = (sentiment, resetKey = "") => {
  const previousRef = useRef(null);
  const [delta, setDelta] = useState(null);
  const value = useMemo(() => normalizeSentimentValue(sentiment), [sentiment]);

  useEffect(() => {
    previousRef.current = null;
    setDelta(null);
  }, [resetKey]);

  useEffect(() => {
    if (value == null) return;
    if (previousRef.current != null) setDelta(value - previousRef.current);
    previousRef.current = value;
  }, [value]);

  return { value, delta };
};
